import React, { createContext, useContext, useEffect, useState } from 'react';

const CmsContext = createContext({});

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4001';

export function CmsProvider({ children }) {
  const [sections, setSections] = useState({});
  const [loaded, setLoaded] = useState(false);

  const fetchSections = () => {
    fetch(`${API_BASE}/api/cms`)
      .then(r => r.json())
      .then(data => setSections(data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  };

  useEffect(() => { fetchSections(); }, []);

  return (
    <CmsContext.Provider value={{ sections, loaded, refresh: fetchSections }}>
      {children}
    </CmsContext.Provider>
  );
}

export function useCms(sectionKey, fallback = {}) {
  const { sections } = useContext(CmsContext);
  return sections[sectionKey] || fallback;
}

export function useCmsLoaded() {
  const { loaded } = useContext(CmsContext);
  return loaded;
}

export default CmsContext;
